import clsx from 'clsx'
import { PaperclipIcon } from 'lucide-react'
import { useToasts } from '../../../../../hooks'
import { useTranslation } from 'react-i18next'
import { v4 as uuid } from 'uuid'
import { UUID } from '@indigohive/cogfy-types'

export type ChatFileInputProps = {
  files: { id: UUID, file: File }[]
  onFilesChange?: (files: { id: UUID, file: File }[]) => void
}

const MAX_FILES_TO_UPLOAD = 5
const MAX_FILE_SIZE_IN_MB = 100
const MAX_FILE_SIZE_IN_B = MAX_FILE_SIZE_IN_MB * 1024 * 1024

export function ChatFileInput (props: ChatFileInputProps) {
  const { files, onFilesChange } = props

  const toast = useToasts()
  const { t } = useTranslation()

  const handleUploadFiles = (filesToUpload: File[]) => {
    const someFileExceedsLimit = filesToUpload.some(file => file.size > MAX_FILE_SIZE_IN_B)

    if (someFileExceedsLimit) {
      return toast.error(t('File size exceeds the limit of {{maxSize}} MB', { maxSize: MAX_FILE_SIZE_IN_MB }))
    }

    const newFiles = [...files, ...filesToUpload.map(file => ({ id: uuid() as UUID, file }))]

    if (newFiles.length > MAX_FILES_TO_UPLOAD) {
      return toast.error(t('You can only upload up to {{maxFilesToUpload}} files', { maxFilesToUpload: MAX_FILES_TO_UPLOAD }))
    }

    onFilesChange?.(newFiles)
  }

  return (
    <label className="btn btn-primary btn-circle btn-ghost">
      <input
        disabled={files.length >= 5}
        type="file"
        className="hidden"
        multiple={true}
        onChange={event => {
          if (event.target.files) {
            handleUploadFiles?.(Array.from(event.target.files))
          }
        }}
      />
      <PaperclipIcon
        size={20}
        className={clsx(files.length >= 5 ? 'text-neutral-content' : 'text-primary')}
      />
    </label>
  )
}
